import { useState, useRef, useCallback, useMemo } from "react"
import { motion, AnimatePresence } from "framer-motion";

import useAppStore from "../../store/useAppStore"
import useLayoutStore from "../../store/useLayoutStore"

const SearchBar = () => {
    const isTouchDevice = useLayoutStore(state => state.isTouchDevice)
    const isDarkTheme = useLayoutStore(state => state.isDarkTheme)

    const setPresenceVisibility = useAppStore((state) => state.setPresenceVisibility)
    const setDevicesVisibility = useAppStore((state) => state.setDevicesVisibility)
    const filterEmployeesBySearch = useAppStore((state) => state.filterEmployeesBySearch)
    const filterDevicesBySearch = useAppStore((state) => state.filterDevicesBySearch)

    const [mouseEnter, setMouseEnter] = useState(false);
    const [isEmpty, setIsEmpty] = useState(true);

    const inputRef = useRef(null)
    const firstInputTriggered = useRef(false)

    const handleMouseEnter = () => {
        setMouseEnter(true)
        inputRef.current?.focus()
    }

    const handleMouseLeave = () => {
        setMouseEnter(false)
        if (isEmpty && inputRef.current) {
            inputRef.current.blur()
            firstInputTriggered.current = false
        }
    }

    const handleInputValueChange = (e) => {
        const value = e.target.value
        const activeSection = useAppStore.getState().activeSection

        if (activeSection === 'Prisutnost') filterEmployeesBySearch(value)
        else if (activeSection === "Status uređaja") filterDevicesBySearch(value)

        const emptyNow = value.trim() === ""
        setIsEmpty(emptyNow)

        if (!emptyNow && !firstInputTriggered.current) {
            if (activeSection === "Prisutnost") setPresenceVisibility("allEmployees")
            else if (activeSection === "Status uređaja") setDevicesVisibility("allDevices")
            firstInputTriggered.current = true
        }
    }

    const handleClearInput = () => {
        if (inputRef.current) {
            inputRef.current.value = ""
            inputRef.current.focus()
        }
        const activeSection = useAppStore.getState().activeSection
        if (activeSection === "Prisutnost") filterEmployeesBySearch("")
        else if (activeSection === "Status uređaja") filterDevicesBySearch("")
        firstInputTriggered.current = false
        setIsEmpty(true)
    }

    const isExpanded = mouseEnter || !isEmpty

    const searchWidth = useMemo(() => {
        const activeSection = useAppStore.getState().activeSection
        if (activeSection === "Status uređaja") return 234
        else return 269
    }, [])

    const bgColor = isDarkTheme ? 'bg-dark' : ''

    return (
        <div className="v-search-container">
            <motion.div
                className={`v-search-div ${isDarkTheme ? 'dark-search' : 'white-search'}`}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                initial={{ width: 47 }}
                animate={{ width: isExpanded ? searchWidth : 47 }}
                transition={{ type: "spring", stiffness: 300, damping: 25 }}
            >
                <motion.input
                    ref={inputRef}
                    name="presence-search-input"
                    className={`v-search-input ${isDarkTheme ? 'dark-color' : ''}`}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: isExpanded ? 1 : 0 }}
                    transition={{ duration: 0.2 }}
                    onChange={handleInputValueChange}
                />
            </motion.div>
            {isTouchDevice ? (
                <AnimatePresence mode="wait" initial={false}>
                    {!isExpanded ? (
                        <motion.img
                            key="search-icon"
                            className={`${isDarkTheme ? 'dark-filter' : ''}`}
                            src="./sidebar/Pretrazivanje.svg"
                            alt="Search Icon"
                            initial={{ scale: 0, opacity: 0.49 }}
                            animate={{ scale: 1, opacity: 1 }}
                            exit={{ scale: 0, opacity: 0 }}
                            transition={{ duration: 0.14 }}
                        />
                    ) : (
                        <motion.div
                            key="clear-icon"
                            className="v-search-clear"
                            onClick={handleClearInput}
                            initial={{ scale: 0, opacity: 0.49 }}
                            animate={{ scale: 1, opacity: 1 }}
                            exit={{ scale: 0, opacity: 0 }}
                            transition={{ duration: 0.14 }}
                        >
                            <div className={`v-search-clear-line1 ${bgColor}`}></div>
                            <div className={`v-search-clear-line2 ${bgColor}`}></div>
                        </motion.div>
                    )}
                </AnimatePresence>
            ) : (
                <AnimatePresence mode="wait" initial={false}>
                    {isEmpty ? (
                        <motion.img
                            key="search-icon"
                            className={`${isDarkTheme ? 'dark-filter' : ''}`}
                            src="./sidebar/Pretrazivanje.svg"
                            alt="Search Icon"
                            initial={{ scale: 0, opacity: 0.49 }}
                            animate={{ scale: 1, opacity: 1 }}
                            exit={{ scale: 0, opacity: 0 }}
                            transition={{ duration: 0.14 }}
                        />
                    ) : (
                        <motion.div
                            key="clear-icon"
                            className="v-search-clear"
                            onClick={handleClearInput}
                            initial={{ scale: 0, opacity: 0.49 }}
                            animate={{ scale: 1, opacity: 1 }}
                            exit={{ scale: 0, opacity: 0 }}
                            transition={{ duration: 0.14 }}
                        >
                            <div className={`v-search-clear-line1 ${bgColor}`}></div>
                            <div className={`v-search-clear-line2 ${bgColor}`}></div>
                        </motion.div>
                    )}
                </AnimatePresence>
            )}

        </div >
    )
}

export default SearchBar
// mozda PresenceSearchBar?!